import { AddCustomer } from "api/models/request/customer/customer";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { string } from "yup";
export const customerFormSchema = (): ObjectSchemaType<AddCustomer> => ({
  code: {
    type: InputType.text,
    gridSize: 4,
    label: "Mã khách hàng",
    validattionYupSchema: string().required().max(255),
  },
  name: {
    type: InputType.text,
    gridSize: 8,
    label: "Tên khách hàng",
    validattionYupSchema: string().required().max(255),
  },
  dealingName: {
    type: InputType.text,
    gridSize: 6,
    label: "Tên giao dịch",
    validattionYupSchema: string().required().max(255),
  },
  taxCode: {
    type: InputType.text,
    gridSize: 6,
    label: "Mã số thuế",
    validattionYupSchema: string().required().max(50),
  },
  customerTypeId: {
    type: InputType.select,
    gridSize: 12,
    label: "Loại khách hàng",
    validattionYupSchema: string().required(),
  },
  headOfficeAddress: {
    type: InputType.text,
    gridSize: 12,
    label: "Địa chỉ",
    validattionYupSchema: string().required().max(255),
  },
  note: {
    type: InputType.textArea,
    gridSize: 12,
    label: "Ghi chú",
    metaData: {
      rows: 3,
    },
    validattionYupSchema: string().max(255),
  },
  isDisabled: {
    type: InputType.checkbox,
    gridSize: 12,
    label: "Ngưng sản xuất",
  },
  deliveryAddresses: {
    type: InputType.array,
    label: "Danh sách địa chỉ giao hàng",
    gridSize: 12,
    arraySchema: {
      id: {
        type: InputType.none,
      },
      address: {
        type: InputType.text,
        gridSize: 12,
        label: "Địa chỉ giao hàng",
        validattionYupSchema: string().required().max(255),
        defaultValue: "",
      },
    },
  },
});
